export const GET_DOCUMENTS_ACTIONS = {
    GET_DOCUMENTS_STARTED: 'GET_DOCUMENTS_ACTION_STARTED',
    GET_DOCUMENTS_OK: 'GET_DOCUMENTS_ACTION_OK',
    GET_DOCUMENTS_ERROR: 'GET_DOCUMENTS_ACTION_ERROR',
    GET_DOCUMENTS_INVALID_RESPONSE: 'GET_DOCUMENTS_ACTION_INVALID_RESPONSE',
    GET_DOCUMENTS_INVALID_JSON: 'GET_DOCUMENTS_ACTION_INVALID_JSON',
}
